/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationSpotCvDownload = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationSpotCvDownload"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="var(--xdlColorIllustrationBackground)"
        d="M59.42 45.08V6.01h-2.15V3.75h-4.45c-.86-1.71-2.61-2.9-4.66-2.9s-3.8 1.19-4.66 2.9H9.06v60.32h2.15v2.26h39.44c1.44.65 3.03 1.02 4.71 1.02 6.35 0 11.51-5.17 11.51-11.51 0-4.92-3.1-9.11-7.45-10.76"
      />
      <path
        fill="#fff"
        d="M45.84 55.84c0-5.23 4.21-9.46 9.43-9.51V5.75H11.06v56.32h37.13a9.44 9.44 0 0 1-2.34-6.24z"
      />
      <path
        fill="#B7E854"
        d="M22.55 19.13a4.22 4.22 0 1 0 0-8.44 4.22 4.22 0 0 0 0 8.44"
      />
      <path
        fill="#27DBA8"
        d="M55.36 65.35a9.51 9.51 0 1 0 0-19.02 9.51 9.51 0 0 0 0 19.02"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="M22.55 19.63c-2.6 0-4.72-2.12-4.72-4.72s2.12-4.72 4.72-4.72 4.72 2.12 4.72 4.72-2.12 4.72-4.72 4.72m0-8.44c-2.05 0-3.72 1.67-3.72 3.72s1.67 3.72 3.72 3.72 3.72-1.67 3.72-3.72-1.67-3.72-3.72-3.72M27.64 24.02c-.9-1.91-2.57-2.89-4.96-2.93-2.32 0-4.38 1.12-5.22 2.92l-.91-.42c1-2.17 3.38-3.52 6.14-3.5 2.76.04 4.78 1.25 5.85 3.5zM51.03 16.08H34.34v1h16.69zM51.03 19.82H34.34v1h16.69zM51.03 23.56H34.34v1h16.69zM51.02 27.3H15.64v1h35.38zM51.02 31.04H15.64v1h35.38zM51.12 34.77H15.74v1h35.38zM51.12 42.32H22.34v1h28.78zM17.27 44.95c-1.17 0-2.13-.96-2.13-2.13s.96-2.13 2.13-2.13 2.13.96 2.13 2.13-.96 2.13-2.13 2.13m0-3.26c-.62 0-1.13.51-1.13 1.13s.51 1.13 1.13 1.13 1.13-.51 1.13-1.13-.51-1.13-1.13-1.13M17.27 56.03c-1.17 0-2.13-.96-2.13-2.13s.96-2.13 2.13-2.13 2.13.96 2.13 2.13-.96 2.13-2.13 2.13m0-3.26c-.62 0-1.13.51-1.13 1.13s.51 1.13 1.13 1.13 1.13-.51 1.13-1.13-.51-1.13-1.13-1.13M17.17 46.44c-1.12 0-2.02.96-2.02 2.13s.91 2.13 2.02 2.13 2.02-.96 2.02-2.13-.91-2.13-2.02-2.13m0 3.26c-.59 0-1.07-.51-1.07-1.13s.48-1.13 1.07-1.13 1.07.51 1.07 1.13-.48 1.13-1.07 1.13"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="M57.42 46.04V8.01h-1.65V5.25h-3.98a3.73 3.73 0 0 0-3.63-2.9 3.73 3.73 0 0 0-3.63 2.9H10.56v57.32h2.65v1.76h36.88c1.53.96 3.34 1.52 5.27 1.52 5.52 0 10.01-4.49 10.01-10.01 0-4.81-3.41-8.84-7.95-9.8M48.16 3.35c1.21 0 2.23.8 2.59 1.9h-5.17c.35-1.1 1.37-1.9 2.59-1.9zm-36.6 58.23V6.25h32.88v5.53c0 1.18.96 2.15 2.15 2.15s2.15-.96 2.15-2.15V7.23h-1v4.55a1.15 1.15 0 0 1-2.3 0V6.25h9.33v39.6c-2.15.12-4.11.94-5.69 2.21H21.97v1H48a10 10 0 0 0-2.35 4.33H22.33v1h23.12c-.07.47-.11.95-.11 1.44 0 2.14.68 4.11 1.83 5.74H11.56zm43.8 3.27c-4.97 0-9.01-4.04-9.01-9.01s4.04-9.01 9.01-9.01 9.01 4.04 9.01 9.01-4.04 9.01-9.01 9.01"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="M55.86 58.83v-8.79h-1v8.79l-2.82-2.82-.71.7 4.03 4.04 4.04-4.04-.71-.7z"
      />
    </svg>
  );
};
export default IllustrationSpotCvDownload;
